import * as React from "react";
import { TextareaAutosize, TextareaAutosizeProps } from "@aichat/ui";
import { cn } from "@aichat/ui/lib/utils";

const ChatInput__V2 = React.forwardRef<
  HTMLTextAreaElement,
  TextareaAutosizeProps & { brandHSLAString?: string }
>(({ className, ...props }, ref) => {
  return (
    <>
      <style>
        {`.chat-input:focus-visible {
              border-color: ${props.brandHSLAString} !important;
        }`}
      </style>
      <TextareaAutosize
        autoComplete="off"
        ref={ref}
        name="message"
        maxRows={2}
        className={cn(
          "chat-input px-4 py-3 bg-background text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full flex items-center resize-none",
          className,
        )}
        {...props}
      />
    </>
  );
});
ChatInput__V2.displayName = "ChatInput";

export { ChatInput__V2 };
